<script>
import WhatsApp from "@/components/whatsapp";

export default {
  components: {
    WhatsApp,
  },
  beforeCreate: function() {
    document.body.className = 'auth';
  }
};
</script>

<template>
  <div class="account-page">
    <slot />
    <WhatsApp />
  </div>
</template>
